import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ type: "spring", stiffness: 90, damping: 18, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ overline, title, description, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <span className="overline" data-testid="section-overline">{overline}</span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-3xl md:text-5xl leading-[1.05] tracking-tight font-bold mt-4">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="text-base md:text-lg text-gray-400 font-light mt-5 leading-relaxed">
          {description}
        </p>
      </Reveal>
    )}
  </div>
);
